import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import MetricList from "@/features/certifications/analytics/components/MetricList";
import { StatsCardProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const QUEUES = ["knowledgeChecks", "contributions"] as const;

const ReviewQueueCard = ({ data, isLoading, isError }: StatsCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.reviewQueue";

  return (
    <AnalyticsCard
      title={t(`${prefix}.title`)}
      isLoading={isLoading}
      isError={isError}
    >
      {data && (
        <div className="flex flex-col gap-400">
          {QUEUES.map((queue) => {
            const entry = data.reviewQueue[queue];
            const oldest = entry.oldestPendingHumanAt
              ? DateTime.fromISO(entry.oldestPendingHumanAt).toRelative()
              : null;
            return (
              <div key={queue} className="flex flex-col gap-200">
                <h4 className="analytics-title body-s-medium">
                  {t(`${prefix}.queues.${queue}`)}
                </h4>

                <MetricList
                  rows={[
                    {
                      key: "withAi",
                      label: t(`${prefix}.withAi`),
                      value: entry.withAi,
                    },
                    {
                      key: "pendingHuman",
                      label: t(`${prefix}.pendingHuman`),
                      value: entry.pendingHuman,
                    },
                    {
                      key: "oldest",
                      label: t(`${prefix}.oldest`),
                      value: oldest ?? t("charts.noValue"),
                    },
                  ]}
                />
              </div>
            );
          })}
        </div>
      )}
    </AnalyticsCard>
  );
};

export default ReviewQueueCard;
